module.exports = __webpack_public_path__ + "img/queue_play_next.5afa1618.svg";